import type { ReactElement } from "react";
import { IconProps, SvgIcon } from "./SvgIcon";

export function CrossCircleIcon({
  className,
  color = "currentColor",
  size,
}: IconProps): ReactElement {
  return (
    <SvgIcon size={size} className={className}>
      <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2" />
      <path
        d="M14.4749 9.52515L9.52517 14.4749"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M14.4749 14.4749L9.52517 9.52517"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
